import posthogLib, { type PostHog } from 'posthog-js';

let posthog: PostHog;

const options = {
  ui_host: 'https://eu.posthog.com',
  api_host: 'https://posthog-proxy.figmaweave.com',
};

const getQueryParam = (param: string): string | null => {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const shouldEnableAllFlags = () => {
  const envFlag = import.meta.env.VITE_ENABLE_ALL_FEATURE_FLAGS === 'true';
  const queryFlag = getQueryParam('enableAllFeatureFlags') === 'true';
  return envFlag || queryFlag;
};

const shouldDisableAllFlags = () => {
  return getQueryParam('disableAllFeatureFlags') === 'true';
};

let flagsOverridden = false;

export const initPosthog = () => {
  if (!posthog) {
    posthog = posthogLib.init('phc_NT2sOH8m82boUw21Q1Vsr0tQUtjpRJUIE5aoqA0En8T', options);

    const enableAll = shouldEnableAllFlags();
    const disableAll = shouldDisableAllFlags();

    // Override feature flags based on query params or env variables
    if (enableAll || disableAll) {
      posthog.onFeatureFlags(() => {
        if (flagsOverridden) return;
        flagsOverridden = true;

        const flagKeys = posthog.featureFlags.getFlags();
        const overriddenFlags = flagKeys.reduce<Record<string, boolean>>((acc, flag) => {
          acc[flag] = enableAll ? true : false;
          return acc;
        }, {});

        posthog.featureFlags.overrideFeatureFlags({ flags: overriddenFlags });
      });
    } else {
      // clear all overrides
      posthog.featureFlags.overrideFeatureFlags(false);
    }
  }
};

initPosthog();

export { posthog };
